import React from 'react'
import Picture from '../../components/Picture'
import { Fragment } from 'react'


export default function () {
    return (
        <Fragment>
            <div className="mercos-pay-section">
                <div className="container home-two-col ">
                    <div className="column">
                        <h2 className="title">Mercos Pay</h2>
                        <h3 className="description">Sistema de pagamentos da Mercos</h3>
                        <p><b>Indústrias e distribuidoras podem receber o pagamento dos seus pedidos direto pelo Mercos com praticidade e segurança</b> </p>
                        <Picture
                            className='purple-col-img-mobile mobile-only'
                            src="/images/site/new-home/mercos-pay.png"
                            alt='Mercos Pay - Sistema de pagamentos da Mercos'
                        />
                        <div className="checklist">
                            <div className="checklist-item">
                                <div className="checkmark checkmark-green"> </div>
                                <p>Permita que o seu cliente faça o pagamento no checkout do seu e-commerce B2B da Mercos, por <b>boleto bancário, cartão de crédito e PIX.</b></p>
                            </div>
                            <div className="checklist-item">
                                <div className="checkmark checkmark-green">&nbsp;</div>
                                <p>Gere um link de pagamento nos pedidos realizados pelo sistema da Mercos com cobranças únicas, parceladas, mistas ou com mais de um cartão.</p>
                            </div>
                            <div className="checklist-item">
                                <div className="checkmark checkmark-green"> </div>
                                <p>Taxas atrativas e você só paga se usar!  </p>
                            </div>
                        </div>
                        <a className="new-button button-primary" href="/mercos-pay/">saiba mais</a>
                    </div>
                    <div className="column">
                        <Picture
                            className='purple-col-img-mobile desktop-only'
                            src="/images/site/new-home/mercos-pay.png"
                            alt='Mercos Pay - Sistema de pagamentos da Mercos'
                        />
                    </div>
                </div>
            </div>
        </Fragment>
    )
}




// WEBPACK FOOTER //
// /usr/src/site-blog/src/blocks/TwoCols/MercosPay.jsx